import { apiClient } from "../config";

async function updateFormFields(id: string | number, data: any) {
  const res = await apiClient.put(`/admin/dynamic-forms/${id}/fields`, data);
  return res.data;
}

export default updateFormFields;
